import React from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import moment from 'moment';
import NewSlotForm from './NewSlotForm';
// import NewBlockForm from './NewBlockForm';
import tabify from 'shared/containers/tabify';
import classes from './NewSlotModal.module.scss';

const TabPane = ({ children }) => <div className={classes.tab_pane}>{children}</div>;

TabPane.displayName = 'TabPane';

const Tabs = tabify(({ children, tabs, setActiveTabName, span }) => (
  <div>
    <div className={classes.slot_or_block_selector}>
      {tabs.map(tab => (
        <div
          key={tab.name}
          className={cx(classes.tab, {
            [classes.active]: tab.active,
            [classes.inactive]: !tab.active,
          })}
          onClick={() => setActiveTabName(tab.name)}
        >
          {tab.name}
        </div>
      ))}
    </div>
    <div className={classes.tab_content}>{children}</div>
  </div>
));

Tabs.displayName = 'Tabs';

const NewSlotModal = ({ slotInfo, selectedLocationId }) => {
  // eslint-disable-line
  // console.log(slotInfo);
  return (
    <div className={`${classes.modal_container} proxima_nova`}>
      <Tabs>
        <TabPane tabName="New Slot">
          <NewSlotForm
            selectionStart={slotInfo.start}
            selectionEnd={slotInfo.end}
            initialValues={{
              selectionStartDate: moment(slotInfo.start).format('MM/DD/YYYY'),
              selectionEndDate: moment(slotInfo.end).format('MM/DD/YYYY'),
              selectionStartTime: moment(slotInfo.start).format('hh:mm a'),
              selectionEndTime: moment(slotInfo.end).format('hh:mm a'),
              repeatUnit: 'weekly',
              repeatStartsOn: moment(slotInfo.start).format('MM/DD/YYYY'),
              permitSelfReferral: true,
              repeat: false,
              highPriorityOnly: false,
              locationId: selectedLocationId,
            }}
          />
        </TabPane>
        <TabPane tabName="New Block">
          <div className={classes.coming_soon_notice}>
            <p>Feature Coming Soon</p>
          </div>
          {/* <NewBlockForm
            selectionStart={slotInfo.start}
            selectionEnd={slotInfo.end}
            initialValues={{
              selectionStartDate: moment(slotInfo.start).format('MM/DD/YYYY'),
              selectionEndDate: moment(slotInfo.end).format("MM/DD/YYYY"),
              selectionStartTime: moment(slotInfo.start).format("h:mm a"),
              selectionEndTime: moment(slotInfo.end).format("h:mm a"),
              repeatUnit: 'weekly',
              repeatStartsOn: moment(slotInfo.start).format("MM/DD/YYYY"),
              slotLength: 30,
              slotConcurrency: 1,
              repeat: false
            }}
          /> */}
        </TabPane>
      </Tabs>
    </div>
  );
};

NewSlotModal.displayName = 'NewSlotModal';

function mapStateToProps({ calendar }) {
  return {
    slotInfo: calendar.slotInfo,
    selectedLocationId: calendar.selectedLocationId,
  };
}

export default connect(mapStateToProps)(NewSlotModal);
